<template>
  <div class="flex space-x-3">
    <button
      @click="setLang('id')"
      :class="['tab-btn', lang === 'id' ? 'active' : '']"
    >
      Indonesia
    </button>

    <button
      @click="setLang('en')"
      :class="['tab-btn', lang === 'en' ? 'active' : '']"
    >
      English
    </button>
  </div>
</template>

<script>
export default {
  props: {
    modelValue: String
  },
  computed: {
    lang: {
      get() { return this.modelValue },
      set(v) { this.$emit('update:modelValue', v) }
    }
  },
  methods: {
    setLang(l) {
      this.lang = l;
    }
  }
};
</script>

<style scoped>
.tab-btn {
  background: #d8ebff;
  padding: 10px 22px;
  font-weight: 700;
  border-radius: 20px;
  font-size: 16px;
  border: 2px solid #9ac7ff;
  color: #4a4a4a;
  transition: 0.2s;
}
.tab-btn.active {
  background: #7bc6ff;
  border-color: #4fa7ff;
  color: white;
  box-shadow: 0 4px 10px rgba(0, 150, 255, 0.3);
}
.tab-btn:hover {
  transform: scale(1.05);
}
</style>
